import React, { useContext } from "react";
import ThemeContext from "../../../utils/Contexts/ThemeContext";
import Constant from "../../Constants";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import DashGuideOffer from "../../../images/dashboard-guide-offers.svg";
import DashGuideWeb from "../../../images/dashboard-guide-web.svg";
import DashGuideOfferLight from "../../../images/Dashboard-Guide-Offer-Light.svg";
import DashGuideWebLight from "../../../images/Dashboard-Guide-Web-Light.svg";
import RightIcon from "../../svg/RightIcon";
import RightArrow from "../../svg/RightArrow";

function AppGuide() {
  const { t } = useContext(LanguageContext);
  const { themeStatus } = Constant();
  const { selectedTheme } = useContext(ThemeContext);

  return (
    <div
      className={`w-100 py-4 px-3 rounded cardSetting app-guide-height ${themeStatus?.[selectedTheme]}`}
      style={{ backgroundColor: "var(--bg-card)", lineHeight: "150%" }}
    >
      <div className="d-flex align-items-center pb-4">
        <h4 className="dashboard-title-responsive mb-0">
          {t("Get started with Backlinks Factory")}
        </h4>
      </div>

      <div
        className="mb-3"
        style={{
          borderBottom: `2px solid var(--border)`,
          marginLeft: "-18px",
          marginRight: "-18px",
        }}
      ></div>

      <div className="row py-2 justify-content-around">
        <div className="col-4_5-1920">
          <img
            src={DashGuideOfferLight}
            className="dash-app-Img"
            data-hs-theme-appearance="default"
            alt="Backlinks Factory"
          />
          <img
            src={DashGuideOffer}
            className="dash-app-Img"
            data-hs-theme-appearance="dark"
            alt="Backlinks Factory"
          />
          <div className="d-flex flex-column gap-4">
            <div>
              <p className="title-app-guide mb-1 mt-3">
                {t("Backlinks Offers")}
              </p>
              <p
                className="card-expiry-balance"
                style={{ color: "var(--dashboard-guide-card)" }}
              >
                {t(
                  "Explore over 102,736 domain and 345,434 backlink offer opportunities"
                )}
              </p>
            </div>
            <span
              style={{ fontSize: "16px", fontWeight: "600" }}
              className="text-primary d-flex align-items-center gap-2"
            >
              {t("Search")} <RightArrow />
            </span>
          </div>
        </div>

        <div className="col-4_5-1920">
          <img
            src={DashGuideWebLight}
            className="dash-app-Img"
            data-hs-theme-appearance="default"
            alt="Backlinks Factory"
          />
          <img
            src={DashGuideWeb}
            className="dash-app-Img"
            data-hs-theme-appearance="dark"
            alt="Backlinks Factory"
          />
          <div className="d-flex flex-column gap-1">
            <div>
              <p className="title-app-guide mb-1 mt-3">
                {t("Effortlessly Website Monetization")}
              </p>
              <p
                className="card-expiry-balance"
                style={{ color: "var(--dashboard-guide-card)" }}
              >
                {t(
                  "Quickly import your websites through our seamless process and start monetizing instantly"
                )}
              </p>
            </div>
            <span
              style={{ fontSize: "16px", fontWeight: "600" }}
              className="text-primary d-flex align-items-center gap-2"
            >
              {t("Import")} <RightArrow />
            </span>
          </div>
        </div>

        <div className="col-1920-3 app-guide-tabs" style={{ gap: "15px" }}>
          <div
            className="app-guide-tabs-content "
            style={{
              background: "var(--apex-tooltip)",
              border: "var(--apex-border)",
              boxShadow: "var(--apex-box-shadow)",
              borderRadius: "10px",
            }}
          >
            <div className="d-flex justify-content-between align-items-center px-3 h-100">
              <div className="d-flex flex-column app-guide-tabs-space">
                <p
                  className="card-text p-0 m-0"
                  style={{ color: "var(--whiteToBlack)" }}
                >
                  {t("Need help getting started?")}
                </p>
                <p className="p-0 m-0 guide-tab-text">
                  {t("Contact a product specialist.")}
                </p>
              </div>
              <RightIcon color={"rgba(108, 116, 122, 1)"} />
            </div>
          </div>

          <div
            className="app-guide-tabs-content"
            style={{
              background: "var(--apex-tooltip)",
              border: "var(--apex-border)",
              boxShadow: "var(--apex-box-shadow)",
              borderRadius: "10px",
            }}
          >
            <div className="d-flex justify-content-between align-items-center px-3 h-100">
              <div className="d-flex flex-column app-guide-tabs-space">
                <p
                  className="card-text p-0 m-0"
                  style={{ color: "var(--whiteToBlack)" }}
                >
                  {t("How to get a high seller rating?")}
                </p>
                <p className="p-0 m-0 guide-tab-text">
                  {t("Read the article.")}
                </p>
              </div>
              <RightIcon color={"rgba(108, 116, 122, 1)"} />
            </div>
          </div>

          <div
            className="app-guide-tabs-content "
            style={{
              background: "var(--apex-tooltip)",
              border: "var(--apex-border)",
              boxShadow: "var(--apex-box-shadow)",
              borderRadius: "10px",
            }}
          >
            <div className="d-flex justify-content-between align-items-center px-3 h-100">
              <div className="d-flex flex-column app-guide-tabs-space">
                <p
                  className="card-text p-0 m-0"
                  style={{ color: "var(--whiteToBlack)" }}
                >
                  {t("What are the withdrawal conditions?")}
                </p>
                <p className="p-0 m-0 guide-tab-text">
                  {t("Contact a product specialist.")}
                </p>
              </div>
              <RightIcon color={"rgba(108, 116, 122, 1)"} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AppGuide;
